import { RefObject, useEffect, useRef } from 'react';
import {usePresentationHold} from './usePresentation';
const scrollLocks=new Set<HTMLElement>();
let savedOverflow='';

export const useModalFocus = (ref: RefObject<HTMLElement>, open: boolean, onClose: () => void, presentation=true) => {
  usePresentationHold(open&&presentation,'Back to the map');
  const close = useRef(onClose);
  close.current = onClose;
  useEffect(() => {
    if (!open || !ref.current) return;
    const dialog = ref.current;
    const previousFocus = document.activeElement as HTMLElement | null;
    if(!scrollLocks.size)savedOverflow=document.body.style.overflow;
    scrollLocks.add(dialog);
    document.body.style.overflow = 'hidden';
    const focusable = () => Array.from(dialog.querySelectorAll<HTMLElement>('button:not(:disabled),input:not(:disabled):not([type="hidden"]),select:not(:disabled),textarea:not(:disabled),a[href],[tabindex="0"]')).filter(element=>element.offsetParent!==null);
    if(dialog.hasAttribute('data-autofocus'))dialog.focus({preventScroll:true});
    else (dialog.querySelector<HTMLElement>('[data-autofocus]') || focusable()[0])?.focus();
    const keydown = (event: KeyboardEvent) => {
      const topDialog=[...document.querySelectorAll<HTMLElement>('[role="dialog"][aria-modal="true"]')].filter(element=>element.getClientRects().length).at(-1);
      if(topDialog&&topDialog!==dialog&&!topDialog.contains(dialog))return;
      if (event.key==='Escape') {event.preventDefault();close.current();}
      if (event.key!=='Tab') return;
      const elements=focusable(), first=elements[0], last=elements[elements.length-1];
      if (!first) {event.preventDefault();return;}
      if (event.shiftKey && (document.activeElement===dialog || document.activeElement===first || !dialog.contains(document.activeElement))) {event.preventDefault();last.focus();}
      else if (!event.shiftKey && (document.activeElement===dialog || document.activeElement===last || !dialog.contains(document.activeElement))) {event.preventDefault();first.focus();}
    };
    document.addEventListener('keydown',keydown);
    return () => {document.removeEventListener('keydown',keydown);scrollLocks.delete(dialog);if(!scrollLocks.size)document.body.style.overflow=savedOverflow;if([...scrollLocks].some(node=>node.contains(document.activeElement)))return;if(previousFocus?.isConnected&&previousFocus!==document.body)previousFocus.focus();else document.getElementById('main-content')?.focus();};
  },[ref,open]);
};
